import { ReportingService } from '../services/reporting.service';
import { FileSaverService } from '../../shared/services/file-saver.service';
import { AlphabeticalNamedSorter } from '../../shared/sort-methods';
import { LoadingWrapperService } from '../../shared/services/loading-wrapper.service';
import { finalize } from 'rxjs/operators';
import { AlertService } from '../../shared/services/alert.service';
import { TransplantReportFormGroup } from './transplant-report-form-group';
var TransplantReportFormComponent = /** @class */ (function () {
    function TransplantReportFormComponent(options, loadingService, alertService, reportingService, reportWriterService) {
        var _this = this;
        this.loadingService = loadingService;
        this.alertService = alertService;
        this.reportingService = reportingService;
        this.reportWriterService = reportWriterService;
        this.rootForm = new TransplantReportFormGroup();
        options.crops.subscribe(function (c) { return _this.crops = c.sort(AlphabeticalNamedSorter); });
        options.potTypes.subscribe(function (f) { return _this.potTypes = f.sort(AlphabeticalNamedSorter); });
        options.substrates.subscribe(function (s) { return _this.substrates = s.sort(AlphabeticalNamedSorter); });
    }
    Object.defineProperty(TransplantReportFormComponent.prototype, "startDateFormControl", {
        get: function () {
            return this.rootForm.startDateFormControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransplantReportFormComponent.prototype, "endDateFormControl", {
        get: function () {
            return this.rootForm.endDateFormControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransplantReportFormComponent.prototype, "cropFormControl", {
        get: function () {
            return this.rootForm.cropFormControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransplantReportFormComponent.prototype, "containerTypeFormControl", {
        get: function () {
            return this.rootForm.containerTypeFormControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransplantReportFormComponent.prototype, "substrateFormControl", {
        get: function () {
            return this.rootForm.substrateFormControl;
        },
        enumerable: true,
        configurable: true
    });
    TransplantReportFormComponent.prototype.ngOnInit = function () {
    };
    TransplantReportFormComponent.prototype.generateReport = function () {
        var _this = this;
        this.loadingService.setMessage('Generating transplant report...');
        this.reportingService.getTransplantReport({
            containerTypeId: this.containerTypeFormControl.value,
            cropId: this.cropFormControl.value,
            endDate: this.endDateFormControl.value,
            startDate: this.startDateFormControl.value,
            substrateId: this.substrateFormControl.value
        })
            .pipe(finalize(function () { return _this.loadingService.clearMessage(); }))
            .subscribe(function (file) { return _this.reportWriterService.save(file); }, function (error) { return _this.alertService.error('Error generating transplant report.'); });
    };
    return TransplantReportFormComponent;
}());
export { TransplantReportFormComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/transplant-report-form/transplant-report-form.component.ts.pre-build-optimizer.js